import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function ComparisonGrid() {
  const { t } = useTranslation();

  const comparisons = [
    {
      icon: "ri-scales-3-line",
      title: t('kakobuy_vs_cssbuy'),
      desc: t('kakobuy_vs_cssbuy_desc'),
      link: "/cssbuy-spreadsheet",
    },
    {
      icon: "ri-scales-line",
      title: t('kakobuy_vs_superbuy'),
      desc: t('kakobuy_vs_superbuy_desc'),
      link: "/superbuy-spreadsheet",
    },
    {
      icon: "ri-equalizer-line",
      title: t('kakobuy_vs_oopbuy'),
      desc: t('kakobuy_vs_oopbuy_desc'),
      link: "/oopbuy-spreadsheet",
    },
  ];

  return (
    <section className="py-16 md:py-24 px-4 md:px-6 lg:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-12 md:mb-16">
          <span className="text-xs font-medium text-foreground-400 tracking-widest uppercase mb-3 block">
            Wartości &amp; Porównania
          </span>
          <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight">
            {t('comparison_title')}
          </h2>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {comparisons.map((item, idx) => (
            <Link
              key={idx}
              to={item.link}
              className="group block bg-background-100 rounded-lg p-6 md:p-8 hover:bg-background-200 transition-colors cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-background-200 text-foreground-700 mb-5 group-hover:bg-accent-100 group-hover:text-accent-600 transition-colors">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-900 mb-3 group-hover:text-accent-600 transition-colors">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
              <div className="mt-4 flex items-center gap-1 text-sm font-medium text-accent-500">
                <span>{t('article_read_more')}</span>
                <i className="ri-arrow-right-line text-xs transition-transform group-hover:translate-x-1"></i>
              </div>
            </Link>
          ))}
        </div>

        {/* Comparison Table */}
        <div className="mt-12 md:mt-16 overflow-x-auto">
          <table className="w-full text-sm text-left border-collapse">
            <thead>
              <tr className="border-b border-background-300">
                <th className="py-3 pr-4 font-semibold text-foreground-700 whitespace-nowrap">Platforma</th>
                <th className="py-3 px-4 font-semibold text-foreground-700 whitespace-nowrap">Jakość Spreadsheet</th>
                <th className="py-3 px-4 font-semibold text-foreground-700 whitespace-nowrap">Baza Produktów</th>
                <th className="py-3 px-4 font-semibold text-foreground-700 whitespace-nowrap">Doświadczenie</th>
                <th className="py-3 pl-4 font-semibold text-foreground-700 whitespace-nowrap">Ocena</th>
              </tr>
            </thead>
            <tbody className="text-foreground-600">
              <tr className="border-b border-background-200">
                <td className="py-3 pr-4 font-semibold text-foreground-900 whitespace-nowrap">Kakobuy</td>
                <td className="py-3 px-4 whitespace-nowrap">Doskonała</td>
                <td className="py-3 px-4 whitespace-nowrap">Duża</td>
                <td className="py-3 px-4 whitespace-nowrap">Łatwe</td>
                <td className="py-3 pl-4 font-semibold text-accent-500 whitespace-nowrap">9.5</td>
              </tr>
              <tr className="border-b border-background-200">
                <td className="py-3 pr-4 font-semibold text-foreground-900 whitespace-nowrap">CSSBuy</td>
                <td className="py-3 px-4 whitespace-nowrap">Dobra</td>
                <td className="py-3 px-4 whitespace-nowrap">Średnia</td>
                <td className="py-3 px-4 whitespace-nowrap">Średnie</td>
                <td className="py-3 pl-4 font-semibold text-foreground-600 whitespace-nowrap">8.2</td>
              </tr>
              <tr className="border-b border-background-200">
                <td className="py-3 pr-4 font-semibold text-foreground-900 whitespace-nowrap">Superbuy</td>
                <td className="py-3 px-4 whitespace-nowrap">Dobra</td>
                <td className="py-3 px-4 whitespace-nowrap">Duża</td>
                <td className="py-3 px-4 whitespace-nowrap">Łatwe</td>
                <td className="py-3 pl-4 font-semibold text-foreground-600 whitespace-nowrap">8.5</td>
              </tr>
              <tr>
                <td className="py-3 pr-4 font-semibold text-foreground-900 whitespace-nowrap">Oopbuy</td>
                <td className="py-3 px-4 whitespace-nowrap">Rosnąca</td>
                <td className="py-3 px-4 whitespace-nowrap">Średnia</td>
                <td className="py-3 px-4 whitespace-nowrap">Łatwe</td>
                <td className="py-3 pl-4 font-semibold text-foreground-600 whitespace-nowrap">8.0</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}